import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import { useTranslation } from 'react-i18next';
import { PATH_METADATA_OMITTED_SNACKBAR_ID, setPathMetadataOmittedWarning, usePathMetadataOmittedWarning } from './pathMetadataOmittedNotification';
import { useMeasuredBottomSnackbarStackIndex } from './SnackbarStackContext';
import { bottomCenterSnackbarStackSx, defaultSnackbarContentSx } from './snackbarStyles';

interface PathMetadataOmittedSnackbarProps {
  stackIndex?: number;
}

const PATH_METADATA_OMITTED_AUTO_HIDE_MS = 8000;

const PathMetadataOmittedSnackbar = ({ stackIndex: stackIndexOverride }: PathMetadataOmittedSnackbarProps) => {
  const { t } = useTranslation();
  const message = usePathMetadataOmittedWarning();
  const open = Boolean(message);

  const { ref: snackbarRef, stackIndex: registeredStackIndex } = useMeasuredBottomSnackbarStackIndex<HTMLDivElement>({
    disabled: stackIndexOverride !== undefined,
    horizontal: 'center',
    open,
  });
  const stackIndex = stackIndexOverride ?? registeredStackIndex;

  const handleDismiss = () => {
    setPathMetadataOmittedWarning(null);
  };

  const handleSnackbarClose = (_event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    handleDismiss();
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      ref={snackbarRef}
      open={open}
      autoHideDuration={PATH_METADATA_OMITTED_AUTO_HIDE_MS}
      onClose={handleSnackbarClose}
      message={message ?? ''}
      action={
        <IconButton size="small" aria-label={t('aria-label.close', 'close')} color="inherit" onClick={handleDismiss}>
          <CloseIcon fontSize="small" />
        </IconButton>
      }
      slotProps={{
        content: {
          id: PATH_METADATA_OMITTED_SNACKBAR_ID,
          role: 'alert',
          sx: defaultSnackbarContentSx,
        },
      }}
      sx={bottomCenterSnackbarStackSx(stackIndex)}
    />
  );
};

export default PathMetadataOmittedSnackbar;
